<template>
        <span v-if="!category" :class="[fullWidth ? 'full-width' : 'tag', 'is-pulled-right']"  v-bind:style="{'background-color' : '#ccc', 'color' : '#000'}" :key="-1">UNKNOWN</span>
        <span v-else-if="category.pivot"  :class="[fullWidth ? 'full-width' : 'tag', 'is-pulled-right']"  v-bind:style="{'background-color' : category.pivot.color, 'color' : category.pivot.text_color}" :key="category.id" >{{category.name}}</span>
        <span v-else :class="[fullWidth ? 'full-width' : 'tag', 'is-pulled-right']" v-bind:style="{'background-color' : '#ccc', 'color' : '#000'}" :key="category.id">{{category.name}}</span>
</template>
<script>

    import _ from 'lodash'

    export default {
        name: 'CategoryTag',
        components: {},
        props:{
            category:{required:true},
            fullWidth:{required:false},
        },
        data() {
            return {
            }
        },
        created(){
            //console.log(this.category);
        },
        mounted(){

        },
        methods: {
        },
        watch: {

        }

    }
</script>

<style lang="css" scoped>

        @media screen and (max-width: 768px){
                span.tag{
                        width: 100%;
                }
        }

        .full-width{
                float: left;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: table-caption;
                font-size: 0.75rem;
                padding: 1% 5%;
                text-align: center;
                border-radius: 3px;
        }

</style>



// WEBPACK FOOTER //
// src/components/category/CategoryTag.vue